import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { formatDate } from '../../../utils/util';

interface DriverContractResponse {
  obtainId: number;
  orderId: number;
  target: string;
  name: string;
  work: string;
}

interface ContractItemsProps {
  items: DriverContractResponse[];
}

export const ContractItems = ({ items }: ContractItemsProps) => {
  return (
    <ContractWrap>
      <ul>
        {items.map((item) => (
          <li key={item.obtainId}>
            <Link
              to={{
                pathname: `/contract/detail/${item.obtainId}`,
                state: {
                  auth: 'user',
                },
              }}
            >
              <div className="l-con">
                <TypeBadge className="type" type={item.work}>
                  {item.work === 'full' ? '전일' : '반일'}
                </TypeBadge>
                <span className="company">{item.name}</span>
              </div>
              <div className="r-con">
                <span className="label">도착날짜</span>
                <span className="date">{item.target.split('T')[0]}</span>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </ContractWrap>
  );
};

// style
const ContractWrap = styled.section`
  ul {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    li {
      a {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: ${(props) => props.theme.textWhiteColor};
        padding: 2.5rem 2.3rem;
        border-radius: 1.6rem;
        .l-con {
          display: flex;
          align-items: center;
          gap: 0.8rem;
          .company {
            font-size: 1.8rem;
            font-weight: 600;
            line-height: 2.2rem;
          }
        }
        .r-con {
          display: flex;
          align-items: center;
          gap: 1.1rem;
          .label {
            font-size: 1.2rem;
            font-weight: 600;
            color: ${(props) => props.theme.textAAAColor};
          }
          .date {
            font-size: 1.3rem;
            font-weight: 600;
          }
        }
      }
    }
  }
`;

const TypeBadge = styled.span<{ type: string }>`
  width: 4.2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 1.1rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  line-height: 2.2rem;
  background-color: ${(props) =>
    props.type === 'full' ? '#00ffba' : '#FFB400'};
  color: ${(props) => props.theme.textBlackColor};
`;
